import React, { useState, useContext, useEffect, useRef } from "react";
import LoadingSpinnerImage from "./LoadingSpinnerImage.js";
import { splitProductsFromRims } from "../Shared/splitProductsFromRims.js";

let debounceTimer = null;

const EntityAssociation = ({ context, entityTypeFilters = []  }) => {
    const AppContext = useContext(context);
    const divRef = useRef(null);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isResultDivVisible, setIsResultDivVisible] = useState(false);
    //const [linkedObjectsList, setLinkedObjectsList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMoreData, setHasMoreData] = useState(true);
    const [itemsPerPageSearchEntity, setItemsPerPageSearchEntity] = useState(10);
    const [currentEntitiesPage, setCurrentEntitiesPage] = useState(1);
    const [showEntitySearchTable, setShowEntitySearchTable] = useState(null);
    const [lastTypeLoaded, setLastTypeLoaded] = useState(null);

    // FUNCTIONS
    // FUNCTIONS
    // FUNCTIONS

    const addItemToLinkedObjects = (item) => {

        if (
            !AppContext.linkedObjectsList.some(
                (element) =>
                    element.EntityType === item.EntityType &&
                    element.EntityId === item.EntityId
            )
        ) {
            let currentList = AppContext.linkedObjectsList;
            let newList = [...currentList, item];

            AppContext.setLinkedObjectsList(newList);
        }
    };

    const removeItemFromLinkedObjects = (item) => {
        let filtered = AppContext.linkedObjectsList.filter(
            (element) =>
                element.EntityType !== item.EntityType ||
                element.EntityId !== item.EntityId
        );

        AppContext.setLinkedObjectsList(filtered);
    };

    const doTextSearchTask = (searchText) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            handleEntitySearchObject({ localSearchText: searchText });
        }, debouncingTime);
    };

    const handleEntitySearchObject = ({ localSearchText = searchText, nextPage = false } = {}) => {


        if (isLoading) return;

        setIsLoading(true);


        let local_entities_page = currentEntitiesPage;

        let local_results = searchResults;
        if (nextPage == false) {
            setHasMoreData(true);
            local_results = [];
            setSearchResults(local_results);
            local_entities_page = 1;
            setCurrentEntitiesPage(local_entities_page);
        } else {
            local_entities_page++;
            setCurrentEntitiesPage(local_entities_page);
        }



        let addTaskSearchObjectURL =
            `/umbraco/api/TaskManagerApi/Entities?` +
            `search=${encodeURIComponent(localSearchText)}&` +
            `entityType=${encodeURIComponent(showEntitySearchTable)}&` +
            `page=${encodeURIComponent(local_entities_page)}&`;

        if (AppContext.useDummy)
            addTaskSearchObjectURL = "https://dummyjson.com/products/search?q=";


        // Do the search

        fetch(addTaskSearchObjectURL)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreData(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((data) => {

                if (AppContext.useDummy) {
                    data = [];

                    let returnNrItems = itemsPerPageSearchEntity;

                    if (local_results.length > 40) returnNrItems = 4;

                    for (let i = 0; i < returnNrItems; i++) {
                        let rnd = Math.round(Math.random() * 1000);
                        data.push({
                            RelationshipId: rnd,
                            EntityName: "systematicreview_" + rnd,
                            EntityType: "systematicreview",
                            EntityId: rnd,
                            Icon: rnd
                        });
                    }
                }

                // Fix to have the same fields being used in the task search>entities and the entity search
                // This will replicate field "EntityName" to "Name" and "EntityUrl" to "Url"

                if (data.length > 0) {
                    data.map((item) => {
                        item.EntityName = item.Name;
                        item.EntityUrl = item.Url;
                        return item;
                    });
                }

                // If the number of items returned for that page is 0 it means there is no more data to retrieve
                if (data.length == 0) setHasMoreData(false);

                // Was it a fetch more request? Then append to tasks.
                if (nextPage) {
                    let res = [...local_results, ...data];
                    setSearchResults(res);
                } else {
                    setSearchResults(data);
                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setIsLoading(false);
                if (localSearchText != "")
                    setLastTypeLoaded(null)
                else
                    setLastTypeLoaded(showEntitySearchTable)
            });
    };



    // USEEFFECTS
    // USEEFFECTS
    // USEEFFECTS

    useEffect(() => {
        // Clear search & results
        setSearchText("");
        setSearchResults([]);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const div_AddTaskSearchEntity = divRef.current;
            if (div_AddTaskSearchEntity) {
                const isBottom =
                    div_AddTaskSearchEntity.scrollTop >=
                    div_AddTaskSearchEntity.scrollHeight -
                    div_AddTaskSearchEntity.clientHeight;

                if (isBottom && !isLoading && hasMoreData) {

                    setIsLoading(true);
                    handleEntitySearchObject({
                        searchText: searchText,
                        nextPage: true
                    });
                }
            }
        };

        // Scroll to load mechanism
        const div_AddTaskSearchEntity = divRef.current;
        if (div_AddTaskSearchEntity) {

            div_AddTaskSearchEntity.addEventListener("scroll", handleScroll);
        }

        return () => {
            // Remove listener for scroll
            if (div_AddTaskSearchEntity)
                div_AddTaskSearchEntity.removeEventListener("scroll", handleScroll);
        };
    }, [isResultDivVisible]);

    useEffect(() => {
        if (searchResults.length > 0)
            if (!isResultDivVisible) setIsResultDivVisible(true);
            else setIsResultDivVisible(false);
    }, [searchResults]);

    ;

    useEffect(() => {
        setSearchText("");
        setSearchResults([]);
    }, [AppContext.clearEntitySearchResults]);


    useEffect(() => {
        if (showEntitySearchTable != null && lastTypeLoaded != showEntitySearchTable) {
            doTextSearchTask(""); // start search with empty string or default query
        }
    }, [showEntitySearchTable]);


    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                setShowEntitySearchTable(null);
                setSearchText("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const targetRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [isLoading]);


    useEffect(() => {

        if (isVisible && hasMoreData && !isLoading) {
            handleEntitySearchObject({ nextPage: true });
        }
    }, [isVisible]);






    // SR items are not searchable from the menu; show that row only when a task already has one linked
    const entityTypesWithSrItems = (() => {
        const list = [...(AppContext.addTaskEntityTypesList || [])];
        const hasLinkedSystematicReviewItem = (AppContext.linkedObjectsList || [])
            .some(obj => obj.EntityType === "systematic-review-item");
        const indexInTaskList = list.findIndex(e => e.EntityType === "systematic-review-item");

        if (hasLinkedSystematicReviewItem && indexInTaskList === -1) {
            const newEntity = {
                EntityGroup: "Systematic Reviews",
                EntityType: "systematic-review-item",
                Name: "Systematic Review Items",
            };
            const groupIndex = list.findIndex(e => e.EntityGroup === newEntity.EntityGroup);
            if (groupIndex !== -1)
                list.splice(groupIndex, 0, newEntity);
            else
                list.unshift(newEntity);
        } else if (!hasLinkedSystematicReviewItem && indexInTaskList !== -1) {
            list.splice(indexInTaskList, 1);
        }

        return list;
    })();

    const linkedToEntityTypes = splitProductsFromRims(entityTypesWithSrItems);

    return (
        <>
            <div>This task is linked to:</div>
            <br />

            {linkedToEntityTypes && linkedToEntityTypes.length > 0 ? (
                <>
                    <table className="results-table" style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th style={{ width: "20%", padding: "5px" }}>Type</th>
                                <th style={{ width: "68%", padding: "5px" }}>Linked Items</th>
                                <th style={{ width: "12%", padding: "5px" }}>Link More</th>
                            </tr>
                        </thead>
                    </table>
                    <div style={{ width: "100%", overflow: "auto" }}>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                {linkedToEntityTypes.map((item, index) => {
                                    const prev = linkedToEntityTypes[index - 1];
                                    const showGroupHeader = !prev || prev.EntityGroup !== item.EntityGroup;

                                    let EntityTypeName =
                                        linkedToEntityTypes.find((type) => type.EntityType === item.EntityType)?.Name ||
                                        AppContext.getStaticEntityTypeName(item.EntityType);

                                    let Entities = AppContext.linkedObjectsList.filter((obj) => obj.EntityType === item.EntityType && obj.EntityName != null);
                                    return (
                                        <React.Fragment key={index}>
                                            {showGroupHeader && (
                                                <tr>
                                                    <td colSpan={3} style={{ fontWeight: "700", color: "#203864", textAlign: "center", padding: "22px 10px 10px 10px", fontSize: "10pt" }}>
                                                        {item.EntityGroup}
                                                    </td>
                                                </tr>
                                            )}
                                            <tr className={index % 2 ? "even-table-row" : "odd-table-row"} style={{ height: "20px" }}>
                                                <td style={{ width: "20%", padding: "5px" }}>
                                                    <span style={{fontWeight: "600", float: "inline-start" }}>{EntityTypeName}</span>
                                                </td>
                                                <td style={{ width: "68%", padding: "5px" }}>
                                                    {Entities.map((entity, i) => (
                                                        <span className="entity-item" key={i}>
                                                            <a
                                                                style={{ border: '1px solid #ccc', borderRadius: '20px', color: "#203864", padding: '2px 12px', background: '#fff', textDecoration: 'none', float: 'inline-start' }}
                                                                target="_blank"
                                                                href={entity.EntityUrl}
                                                                title={`Go to ${EntityTypeName}: ${entity.EntityName}`}
                                                            >
                                                                {entity.EntityName}
                                                            </a>
                                                           
                                                                <span className="entity-remove pointer" onClick={() => removeItemFromLinkedObjects(entity)}>
                                                                <i className="fas fa-times-circle" style={{marginTop: "7px"}} title="Unlink this item"></i>
                                                                </span>
                                                          
                                                        </span>
                                                    ))}
                                                </td>
                                                <td style={{ width: "12%", padding: "5px" }}>
                                                    
                                                    {item.EntityType !== 'systematic-review-item' && (
                                                        <button onClick={() => setShowEntitySearchTable(item.EntityType)} className="addWidgetButton">
                                                            <i className="fas fa-plus-circle" style={{marginRight: "5px"} }></i> Add
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : (
                AppContext.linkedObjectsList?.length === 0 && (
                    <div style={{ color: "#999", textAlign: "center" }}>
                        <i className="fas fa-info-circle g-mr-5"></i> Currently there are no linked items
                    </div>
                )
            )}

            <br />

            {showEntitySearchTable && (
                <div className="link-to-overlay">
                    <div ref={popupRef} className="link-to-content">
                        <button
                            className="link-to-close-btn"
                            onClick={() => {
                                setShowEntitySearchTable(null);
                                setSearchText("");
                            }}
                        >
                            ×
                        </button>

                        <h3 style={{ marginBottom: "20px" }}> <i className="fas fa-project-diagram" style={{ marginRight: "8px" }}></i>Link {AppContext.addTaskEntityTypesList.find((item) => item.EntityType === showEntitySearchTable)?.Name}:</h3>

                        <div className="search-input">
                            <span className="search-icon"><i className="fas fa-search"></i></span>
                            <input
                                type="text"
                                value={searchText}
                                onChange={(e) => {
                                    setSearchText(e.target.value);
                                    doTextSearchTask(e.target.value);
                                }}
                                placeholder={
                                    "Search your " +
                                    AppContext.addTaskEntityTypesList.find((item) => item.EntityType === showEntitySearchTable)?.Name
                                }
                            />
                        </div>

                        <br />
                        {(searchResults.length > 0 || isLoading || !hasMoreData) && (

                            <div style={{ maxHeight: "460px", overflow: "auto" }}>
                                <table className="results-table" style={{ width: "100%" }}>
                                    <thead>
                                        <tr>
                                            <th style={{ width: "70%" }}>Name</th>
                                            <th style={{ width: "30%" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {searchResults.map((item, index) => {
                                            const isAlreadyLinked = AppContext.linkedObjectsList.some(
                                                (linked) => linked.EntityType === item.EntityType && linked.EntityId === item.EntityId
                                            );
                                            return (
                                                <tr key={index} className={index % 2 ? "even-table-row" : "odd-table-row"}>
                                                    <td style={{ width: "70%" }}>
                                                        {["systematic-review-item", "compliance-qms", "compliance-technical-documents"].includes(item.EntityType) ? (
                                                            <span style={{ marginLeft: "15px", float: "inline-start" }}>{item.Name}</span>
                                                        ) : (
                                                                <a target="_blank" style={{ marginLeft: "15px", float: "inline-start" }} href={item.Url}>{item.Name}</a>
                                                        )}
                                                    </td>
                                                    <td style={{ width: "30%" }}>
                                                        <span
                                                            className="pointer"
                                                            onClick={() =>
                                                                isAlreadyLinked
                                                                    ? removeItemFromLinkedObjects(item)
                                                                    : addItemToLinkedObjects(item)
                                                            }
                                                        >
                                                            <span
                                                                style={{
                                                                    borderRadius: "10px",
                                                                    backgroundColor: isAlreadyLinked ? "rgb(192, 192, 192)" : "rgb(180, 220, 255)",
                                                                    padding: "1px 9px",
                                                                    cursor: "pointer"
                                                                }}
                                                                title={isAlreadyLinked ? "Unlink" : "Link this item"}
                                                            >
                                                                {isAlreadyLinked ? "Linked" : "Link"}
                                                            </span>
                                                        </span>
                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>

                                {isLoading ?
                                    <div style={{ textAlign: "center" }}><LoadingSpinnerImage /></div>
                                    :
                                    <>
                                        {/* If this div is visible it should try to load more. Either inner div content or minHeight is mandatory for the intersector to work */}
                                        <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                                    </>
                                }

                                {!hasMoreData && <div className="no-more-results g-mt-30">No more results</div>}

                            </div>
                        )}
                    </div>
                </div>
            )}






        </>
    );
};

export default EntityAssociation;
